export { default } from './svg/layout-icon.svg';
